import { RequestHelper, UrlBuilder } from "@lib-shared/lib";
import { JwtTokens } from "../auth/jwt-tokens";
import { CustomerDetails } from "./customer-details";

type ConnectOptions = {
    proxyUrl: string;
    clientId: string;
    baseUrl: string;
    verifyEndpoint: string;
    redirectUrl: string
}

class ConnectService {
    static options: ConnectOptions;

    private _buildUrl(signIn: boolean, uiLanguage = "en", useJwt = true) {
        const _ = ConnectService.options;
        const path = signIn ? "signin" : "signup";

        const url = new UrlBuilder(_.baseUrl)
            .appendPath("registration")
            .appendPath(path)
            .appendParam("redirect_uri", _.redirectUrl)
            .appendParam("client_id", _.clientId)
            .appendParam("useJwt", useJwt.toString().toLowerCase())
            .appendParam("bypasslinking", "true");
        // .appendParam("lang", uiLanguage);

        return url.toString();
    }

    buildSignInUrl(language = "en", useJwt = true) {
        return this._buildUrl(true, language, useJwt);
    }

    buildSignUpUrl(language = "en", useJwt = true) {
        return this._buildUrl(false, language, useJwt);
    }

    getCustomerDetailsAsync(accessToken: string) {
        if (!accessToken) {
            throw new Error("No access token");
        }

        const path = "customer-details";
        const helper = this._createRequestWithBearerToken(path, accessToken);
        return helper.get<CustomerDetails>();
    }

    refreshTokenAsync(request: JwtTokens) {
        console.log("Refreshing connect token");

        const path = "refresh";
        const helper = this._createRequest(path);
        return helper.post(request);
    }

    validateAsync(request: JwtTokens, refreshToken = false) {
        const path = "validate";
        const helper = this._createRequest(path);

        if (refreshToken) {
            helper.withParams({
                refresh: true
            });
        }

        return helper.post<JwtTokens>(request);
    }

    verifyAsync(authCode: string) {
        const path = "verify";
        const helper = this._createRequest(path);

        const payload = {
            authCode
        };

        return helper.post<JwtTokens>(payload);
    }

    private _createRequest(path: string, direct = false) {
        const _ = ConnectService.options;

        const baseUrl = direct
            ? _.baseUrl
            : _.proxyUrl;

        return new RequestHelper(baseUrl)
            .withPath(path)
            .usingPromise()
            .usingJson();
    }

    private _createRequestWithBearerToken(path: string, token: string, direct = false) {
        return this._createRequest(path, direct).withBearerToken(token);
    }
}

export default ConnectService;
